var DataVolumetryTableModule = /** @class */ (function () {
    function DataVolumetryTableModule() {
    }
    return DataVolumetryTableModule;
}());
export { DataVolumetryTableModule };
